export default "__VITE_ASSET__Cw80KV6H__"